import { LoaderGraphic } from 'app/module/global/LoaderGraphic';
import { Paging } from 'app/module/global/Paging';
import { DragPanel } from 'app/module/global/DragPanel';
import { HitArea } from 'app/module/global/HitArea';
import { VideoSwitch } from 'app/module/project/VideoSwitch';
import { GoogleMap } from 'app/module/info/GoogleMap';
import { ContactForm } from 'app/module/info/ContactForm';
import { LazyLoadImage } from 'app/module/media/LazyLoadImage';
import { DragableVideo } from 'app/module/media/DragableVideo';
import { ParallaxImage } from 'app/module/scroll/ParallaxImage';
import { VideoControls } from 'app/module/media/VideoControls';
import { VideoPlayer } from 'app/module/media/VideoPlayer';
import { Expandable } from 'app/module/media/Expandable';
import { LoadMore } from 'app/module/widget/LoadMore';

declare global {
	namespace DebugbaseModules {
		//ParallaxGroup
		//LoaderGraphic
		export type LoaderGroupModule = LoaderGraphic;
		export const LoaderGroupModule: typeof LoaderGraphic;
		//Paging blocks
		export type PagingModule = Paging;
		export const PagingModule: typeof Paging;
		//Side Drag panel (In projects)
		export type DragPanelModule = DragPanel;
		export const DragPanelModule: typeof DragPanel;
		//Hitarea (For invisible / cancelable touch events on the tiles)
		export type HitAreaModule = HitArea;
		export const HitAreaModule: typeof HitArea;
		//Video switch, for loading mobile / desktop dynamically
		export type VideoSwitchModule = VideoSwitch;
		export const VideoSwitchModule: typeof VideoSwitch;
		//Google maps on info page:
		export type GoogleMapModule = GoogleMap;
		export const GoogleMapModule: typeof GoogleMap;
		//Contact form on info page:
		export type ContactFormModule = ContactForm;
		export const ContactFormModule: typeof ContactForm;
		//LazyLoadImage
		export type LazyLoadImageModule = LazyLoadImage;
		export const LazyLoadImageModule: typeof LazyLoadImage;
		//LoadMore
		export type LoadMoreModule = LoadMore;
		export const LoadMoreModule: typeof LoadMore;
		//ParallaxImage
		export type ParallaxImageModule = ParallaxImage;
		export const ParallaxImageModule: typeof ParallaxImage;
		//DragableVideo
		export type DragableVideoModule = DragableVideo;
		export const DragableVideoModule: typeof DragableVideo;
		//DragableVideo
		export type VideoControlsModule = VideoControls;
		export const VideoControlsModule: typeof VideoControls;
		//VideoPlayer
		export type VideoPlayerModule = VideoPlayer;
		export const VideoPlayerModule: typeof VideoPlayer;
		//Expandable
		export type ExpandableModule = Expandable;
		export const ExpandableModule: typeof Expandable;
	}
}

(<any>window).DebugbaseModules = {
	LoaderGraphic: LoaderGraphic,
	Paging: Paging,
	DragPanel: DragPanel,
	HitArea: HitArea,
	VideoSwitch: VideoSwitch,
	GoogleMap: GoogleMap,
	ContactForm: ContactForm,
	LazyLoadImage: LazyLoadImage,
	LoadMore: LoadMore,
	ParallaxImage: ParallaxImage,
	DragableVideo: DragableVideo,
	VideoControls: VideoControls,
	VideoPlayer: VideoPlayer,
	Expandable: Expandable
};
